import { JRCFormFieldRenderer } from '../Common/JRCFormFieldRenderer';
import * as React from 'react';
import { JRCInputFieldProps } from '../Common/JRCFormFieldRenderer.types';
import jamespot from 'jamespot-user-api';
import { NativeAutocomplete } from './JRCInputAutocomplete';
import { FieldValues } from 'react-hook-form';

const autocompleteCommunity = (inputValue: string) => jamespot.community.autocomplete(inputValue);

export type JRCAutocompleteCommunityProps<T extends FieldValues = FieldValues> = JRCInputFieldProps<T> & {
    multiple?: boolean;
    searchable?: boolean;
};

export function JRCInputCommunity<T extends FieldValues = FieldValues>(
    props: JRCAutocompleteCommunityProps<T>,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _ref: React.ForwardedRef<HTMLInputElement>,
) {
    const { name, control, rules, label, htmlFor, labelIsLegend, description, helper } = props;

    return (
        <JRCFormFieldRenderer
            name={name}
            control={control}
            rules={rules}
            label={label}
            htmlFor={htmlFor}
            labelIsLegend={labelIsLegend}
            description={description}
            helper={helper}
            renderFunction={(field) => (
                <NativeAutocomplete
                    {...props}
                    {...field}
                    asyncPromise={autocompleteCommunity}
                    getSearch="title"
                    showAsyncResultOnEmptySearch
                />
            )}
        />
    );
}
